import { partnerServices } from "../../config/axios";
import { GET_VOUCHER_WIRE_MANAGER_FAILED, GET_VOUCHER_WIRE_MANAGER_SUCCESS, LOADING_GET_VOUCHER_WIRE_MANAGER, NETWORK_ERROR_VOUCHER_WIRE_MANAGER, RESET_GET_VOUCHER_WIRE_MANAGER } from "../types";

const resetGetVoucherWireManager = () => {
    return { type: RESET_GET_VOUCHER_WIRE_MANAGER };
}

const getVoucherWireManager = ( request, authtoken ) => async (dispatch) => {
    dispatch({ type: LOADING_GET_VOUCHER_WIRE_MANAGER });
    await partnerServices
    .post('getVoucherWireManager', request, { headers: { AuthToken: authtoken } })
    .then( res => {
        switch( res.data.status ) {
            case "success":
                dispatch({ type: GET_VOUCHER_WIRE_MANAGER_SUCCESS, payload: res.data });
                break;
            default: 
                dispatch({ type: GET_VOUCHER_WIRE_MANAGER_FAILED, payload: res.data })
        }
    } ) 
    .catch( err => {
        dispatch({ type: NETWORK_ERROR_VOUCHER_WIRE_MANAGER, payload: err });
    } )
}

export { getVoucherWireManager, resetGetVoucherWireManager };